import InstructionIcon from 'assets/img/icons/instruction.svg';
import Button from 'components/_parts/atoms/button';
import Input from 'components/_parts/atoms/input';
import Label from 'components/_parts/atoms/label';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useDispatch } from 'react-redux';
import { HIT_CREATE_FTE, HIT_UPDATE_FTE } from 'redux/actions/wla';
import styled from 'styled-components';
import './index.scss';
import TripleToogle from 'components/_parts/atoms/toogle/triple';
import initialValues from './initialValues';
import validationSchema from './validationSchema';

const labels = [
  {
    id: 'left',
    title: 'Low',
    value: '1',
  },
  {
    id: 'center',
    title: 'Normal',
    value: '0',
  },
  {
    id: 'right',
    title: 'High',
    value: '2',
  },
];

const FullScreenOverlay = styled.div`
  position: fixed;
  height: 100%;
  width: 100%;
  right: 0;
  right: 0;
  top: 0;
`;

const ButtonMod = styled(Button)`
  width: 100%;
  width: 92px;
  height: 40px;
  float: right;
`;
const ButtonInfo = styled(Button)`
  width: 100%;
  width: fit-content;
  height: 40px;
  min-width: 147px;
  border: 1px solid #3d5afe;
  background-color: #ffffff;
  color: #3d5afe;
  padding: 12px 16px;
  column-gap: 10px;
`;

const ColorPicker = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: ${(props) => props.backgroundColor ?? '#3d5afe'};
`;

const LabelPicker = styled.label`
  position: absolute !important;
  right: 6px;
  top: 6px;
`;
const InputColor = styled.input`
  width: 5px;
  height: 5px;
  position: absolute !important;
  top: 23px;
  right: 18px;
  z-index: -1;
`;
function WorkerType(props) {
  const dispatch = useDispatch();
  const { t } = props;

  const formik = useFormik({
    initialValues,
    validationSchema: validationSchema({ t }),
    onSubmit: async (values) => {
      try {
        if (props.typeForm === 'update') {
          dispatch({
            type: HIT_UPDATE_FTE,
            payload: {
              data: {
                ...formik.values,
                is_anomaly: Number(formik.values.is_anomaly),
                wla_fte_limit_id: props.dataLimitFTE.wla_fte_limit_id,
              },
              id: props.ids,
            },
          });
        } else {
          dispatch({
            type: HIT_CREATE_FTE,
            payload: {
              data: {
                ...formik.values,
                is_anomaly: Number(formik.values.is_anomaly),
              },
            },
          });
        }

        props.funcModal(false);
        props.funcId(null);
        props.setTypeForm('');
        formik.resetForm();
      } catch (error) {
        props.funcModal(false);
        props.funcId(null);
        formik.resetForm();
        props.setTypeForm('');
      }
    },
    onChange: (e) => {
      formik.setFieldValue(e.target.name, e.target.value);
    },
  });
  useEffect(() => {
    if (props.typeForm === 'update') {
      formik.setValues({
        name: props.dataLimitFTE?.name,
        range_start: props.dataLimitFTE?.range_start || '',
        range_end: props.dataLimitFTE?.range_end || '',
        color_code: props.dataLimitFTE?.color_code || '',
        is_anomaly: props.dataLimitFTE?.is_anomaly.toString(),
        order: props.dataLimitFTE?.order,
        member: props.dataLimitFTE?.member,
      });
    } else {
      formik.setValues(initialValues);
    }
  }, [props.dataLimitFTE, props.typeForm, props.modal]);

  const handleChange = (value) => {
    formik.setFieldValue('is_anomaly', value);
  };

  return (
    props.modal
        && createPortal(
          <>
            <FullScreenOverlay className="cs_modal-bg" />
            <div
              className="cs_modal-container-activity-type d-flex justify-content-between flex-column"
              ref={props.innerRef}
            >
              <Label
                className="text-center"
                typeLabel="label_modal"
                style={{
                  fontSize: '16px',
                }}
              >
                {`${props?.typeForm === 'update' ? t('org.structure_view.modal.edit') : t('org.structure_view.modal.add')} ${t('company.fte_limit')}`}
              </Label>
              <div className="cs_modal-fteLimit">
                <div>
                  <Input
                    isError={formik.touched.name && Boolean(formik.errors.name)}
                    validateMessage={formik.errors.name}
                    type="text"
                    name="name"
                    onChange={formik.handleChange}
                    value={formik.values.name || ''}
                    placeholder={t('company.limit_name')}
                  />
                </div>
                <div>
                  <Input
                    isError={
                      formik.touched.range_start
                      && Boolean(formik.errors.range_start)
                    }
                    validateMessage={formik.errors.range_start}
                    type="text"
                    name="range_start"
                    onChange={formik.handleChange}
                    value={formik.values.range_start || ''}
                    placeholder={t('company.start_range')}
                  />
                </div>
                <div>
                  <Input
                    isError={
                      formik.touched.range_end
                      && Boolean(formik.errors.range_end)
                    }
                    validateMessage={formik.errors.range_end}
                    type="text"
                    name="range_end"
                    onChange={formik.handleChange}
                    value={formik.values.range_end || ''}
                    placeholder={t('company.end_range')}
                  />
                </div>
                <div className="position-relative">
                  <Input
                    isError={
                      formik.touched.color_code
                      && Boolean(formik.errors.color_code)
                    }
                    validateMessage={formik.errors.color_code}
                    type="text"
                    name="color_code"
                    onChange={formik.handleChange}
                    value={formik.values.color_code || ''}
                    placeholder={t('company.color')}
                    placeholderPosition="start"
                  />
                  <LabelPicker htmlFor="color_picker" className="p-0 m-0">
                    <ColorPicker backgroundColor={formik.values.color_code} />
                  </LabelPicker>
                  <InputColor
                    id="color_picker"
                    value={formik.values.color_code || ''}
                    name="color_code"
                    type="color"
                    className="w-0 position-absolute"
                    onChange={formik.handleChange}
                  />
                </div>
                <div>
                  <Input
                    isError={
                      formik.touched.order && Boolean(formik.errors.order)
                    }
                    validateMessage={formik.errors.order}
                    type="text"
                    name="order"
                    onChange={formik.handleChange}
                    value={formik.values.order || ''}
                    placeholder={t('company.order')}
                  />
                </div>
                <div style={{ gridColumn: 'span 2', marginBottom: '5px' }}>
                  <div className="d-flex w-100 justify-content-between align-items-center">
                    <Label typeLabel="label_text">{t('company.is_anomaly')}</Label>
                    <div style={{ width: '70%' }}>
                      <TripleToogle label={labels} isChecked={formik.values.is_anomaly} position={formik.values.is_anomaly} handleChange={handleChange} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-between">
                <ButtonInfo>
                  <span>
                    <img src={InstructionIcon} alt="" />
                  </span>
                  {t('company.fill_instruction')}
                </ButtonInfo>
                <ButtonMod
                  func={(e) => {
                    formik.handleSubmit(e);
                    setTimeout(() => {
                      props.funcId(null);
                    }, 1000);
                  }}
                >
                  {t('board.save')}
                </ButtonMod>
              </div>
            </div>
          </>,
          document.getElementById('fte_list'),
        )
  );
}

export default WorkerType;
